import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { ProductVariantPriceRangeFragmentDoc } from './ProductVariantPriceRange.generated';
import { VariationPropertyFragmentDoc } from './VariationProperty.generated';
export type AddedProductVariantFragment = { id: string, pk: number, isSupply: boolean, shippingRequired: boolean, sku: string, stockQuantity: number, outOfStockStatus: Types.OutOfStockStatusEnum, stockStatus: Types.OutOfStockStatusEnum | null, priceRange: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } }, allImages: Array<{ id: string, pk: number, alt: string, thumbnailUrl: string | null, url: string }>, properties: Array<{ id: number, pk: number, valueName: string, attributeName: string }> };

export const AddedProductVariantFragmentDoc = gql`
    fragment AddedProductVariantFragment on ProductVariantType {
  id
  pk
  isSupply
  shippingRequired
  sku
  stockQuantity
  outOfStockStatus
  stockStatus
  priceRange {
    ...ProductVariantPriceRangeFragment
  }
  allImages {
    id
    pk
    alt
    url: image
    thumbnailUrl(size: "600x0", method: CROP)
  }
  properties {
    ...VariationPropertyFragment
  }
}
    ${ProductVariantPriceRangeFragmentDoc}
${VariationPropertyFragmentDoc}`;